<script setup lang="ts">
import { Menu, X } from '@lucide/vue';
import { ref } from 'vue';
import AppLogo from '@/components/AppLogo.vue';
const menuOpen = ref(false);
</script>

<template>
  <div class="public-shell">
    <header class="public-header">
      <AppLogo />
      <button class="icon-button mobile-only" @click="menuOpen=!menuOpen" aria-label="Menu"><X v-if="menuOpen" /><Menu v-else /></button>
      <nav :class="{ open:menuOpen }" @click="menuOpen=false">
        <RouterLink to="/">Beranda</RouterLink>
        <RouterLink to="/companies">Perusahaan</RouterLink>
        <RouterLink to="/jobs">Lowongan</RouterLink>
        <RouterLink to="/help">Bantuan</RouterLink>
      </nav>
      <div class="header-actions">
        <RouterLink class="button" to="/auth?mode=tenant">Daftarkan Perusahaan</RouterLink>
        <RouterLink class="button button-dark" to="/portal">Portal Kandidat</RouterLink>
      </div>
    </header>
    <main><RouterView /></main>
    <footer class="public-footer"><AppLogo inverse /><p>Rekrutmen multi-tenant yang transparan, dengan assessment candidate-centric.</p><span>© 2026 RecruitFlow</span></footer>
  </div>
</template>
